import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';
import { aLink } from '@src/utils/common-util';
import { $$tracker } from '@src/tracker';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import cmsApi from '@src/services/cms-api';
const lang = getLanguageByPath();

class CreatorsSectionStore {
  constructor(props = {}) {
    Object.assign(this, { ...props });
  }

  @observable isActive = false;

  @observable creatorProgramLink = `https://mechabreak.seasungames.com/creator_program/${lang}/`;

  @observable JOIN_NOW;

  clickGame = () => {
    // if (this.creatorProgramLink) {
    //   aLink(this.creatorProgramLink);
    // }

    // 问卷
    if (this.JOIN_NOW) {
      aLink(this.JOIN_NOW);
    }

    $$tracker.clickCzz();
  };

  programConfig = async () => {
    return await cmsApi
      .makeCmsCustomConfigRequest('//www.mechabreak.com/api/config/tag/', 'zt/mechabreak_creator_program')
      .then(res => {
        let propName = getLanguageByPath() === 'zh-Hant' ? 'tc_link' : getLanguageByPath() + '_link';
        this.JOIN_NOW = res[propName];
        // this.Aug_Beta_Enrollment = res?.en_questionnaire;
      })
      .catch(e => {
        console.log(e);
      });
  };

  use() {
    useMount(() => {
      this.programConfig();
    });
  }
}

export default CreatorsSectionStore;
